'use client'

import Image from 'next/image'
import { useEffect, useState } from 'react'

import { getBuilderPreviewMode } from '@src/utils/builder.util'
import { getIsServer } from '@src/utils/common.util'

interface Props {
  smartTagId?: string
  attributes: any
}

export function Digioh({ smartTagId, attributes }: Props) {
  const [isDigiohReady, setDigiohReady] = useState(false)
  const { edit } = getBuilderPreviewMode()

  useEffect(() => {
    if (getIsServer()) return

    const interval = setInterval(() => {
      if (window.DIGIOH_API?.LIGHTBOX?.isDigiohReady()) {
        setDigiohReady(true)
        clearInterval(interval)
      }
    }, 100)

    return () => {
      clearInterval(interval)
    }
  }, [])

  if (!getIsServer() && isDigiohReady) {
    window.DIGIOH_API.LIGHTBOX.loadLightbox(smartTagId)
  }
  if (edit) {
    return (
      <Image
        src="/images/digioh_logo.jpeg"
        height={60}
        width={60}
        alt="digioh_img"
        {...attributes}
      />
    )
  }
  return <div id={smartTagId} />
}
